import { render, staticRenderFns } from "./PbgDetail.vue?vue&type=template&id=bc68e90e&"
import script from "./PbgDetail.vue?vue&type=script&lang=js&"
export * from "./PbgDetail.vue?vue&type=script&lang=js&"
import style0 from "./PbgDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports